export default "__VITE_ASSET__bbc2464e__"